import { render, staticRenderFns } from "./ReceiptServices.vue?vue&type=template&id=4927e83a"
import script from "./ReceiptServices.vue?vue&type=script&lang=js"
export * from "./ReceiptServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports